// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { AuthTypeSchema } from '../inputTypeSchemas/AuthTypeSchema'

/////////////////////////////////////////
// AUTHENTICATION SCHEMA
/////////////////////////////////////////

export const AuthenticationSchema = z.object({
  types: AuthTypeSchema.array(),
  ssoProvider: z.string().nullable(),
  description: z.string().nullable(),
})

export type Authentication = z.infer<typeof AuthenticationSchema>

export default AuthenticationSchema;
